import { FC, useCallback, useMemo } from "react";
import { Box } from "@mui/material";
import { Point } from "highcharts";
import { useAppSelector } from "../../../../../../../store/hooks";
import { commitmentsDetailsDrawerDateGranularitySelector } from "../../../../../../../store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerDateGranularitySelector";
import { formatDateByFrequencyType } from "../../../../../../../utils/helpers/date-time/datetime-format";
import { reservationDetailsLoadingSelector } from "../../../../../../../store/commitments/selectors/reservations/details-drawer/data/reservationDetailsLoadingSelector";
import { reservationDetailsGranularDataGroupedByDateSelector } from "../../../../../../../store/commitments/selectors/reservations/details-drawer/reservationDetailsGranularDataGroupedByDateSelector";
import { CommitmentsHighChart } from "@/components/pages/commtiments/common/components/chart/CommitmentsHighChart";
import { generateCommitmentDrawerChartTooltip } from "@/components/pages/commtiments/common/components/drawer/utils/helpers/generateCommitmentDrawerChartTooltip";

interface ReservedInstanceDrawerChartProps {
  ChartHeader?: FC;
  type: "coverage" | "utilization";
}

export const ReservedInstanceDrawerChart: FC<
  ReservedInstanceDrawerChartProps
> = ({ ChartHeader, type }) => {
  const dataGroupedByDate = useAppSelector(
    reservationDetailsGranularDataGroupedByDateSelector,
  );
  const dataPoint = useAppSelector(
    commitmentsDetailsDrawerDateGranularitySelector,
  );
  const loading = useAppSelector(reservationDetailsLoadingSelector);

  const labelFormatter = useCallback(
    (value: string) => formatDateByFrequencyType(dataPoint, value),
    [dataPoint],
  );

  const highChartProps = useMemo(() => {
    return {
      loading,
      dataGroupedByDate,
      labelFormatter,
      maxHeight: 160,
      tooltipMarkupGenerator: (point: Point) =>
        generateCommitmentDrawerChartTooltip({
          point,
          dataGroupedByDate,
          key: type,
        }),
    };
  }, [dataGroupedByDate, loading, labelFormatter, type]);

  return (
    <Box p={1.5}>
      {ChartHeader && <ChartHeader />}
      <CommitmentsHighChart {...highChartProps} />
    </Box>
  );
};
